import { Box, Button, Stack } from '@mui/material';
import * as React from 'react';
const { useResizeDetector } = require("react-resize-detector");

const getScale = (viewportWidth, viewportHeight, targetWidth, targetHeight) => {
    const widthScale = Math.floor(viewportWidth / targetWidth * 100) / 100;
    const heightScale = Math.floor(viewportHeight / targetHeight * 100) / 100;
    return widthScale < heightScale ? widthScale : heightScale;
}

export default function StrechBox(props) {
    const { children, width, height, enableDebugButton, forceOverflow } = props; // ✅ forceOverflow 추가
    const container = useResizeDetector();
    const [scale, setScale] = React.useState(1.0);
    const [useTransform, setUseTransform] = React.useState(true);
    const [optionButtonState, setOptionButtonState] = React.useState({ opacity: 0.0 });

    React.useEffect(() => {
        if (container.width > 0 && container.height > 0 && width > 0 && height > 0) {
            const scaleNew = getScale(container.width, container.height, width, height);
            setScale(scaleNew);
        }
    }, [container.width, container.height, width, height]);

    const onClickHandler = (e) => {
        setUseTransform(prev => !prev);
    }

    const onMouseOverHandler = (e) => {
        setOptionButtonState(prev => ({
            opacity: prev.opacity === 1.0 ? 0.0 : 1.0
        }));
    }

    const scaleTransform = {
        position: 'absolute',
        top: !useTransform ? '0' : '50%',
        left: !useTransform ? '0' : '50%',
        transform: `translate(-50%, -50%) ${useTransform ? `scale(${scale})` : ``}`,
    };

    const originalTransform = {
        position: 'absolute',
        top: !useTransform ? '0' : '50%',
        left: !useTransform ? '0' : '50%',
        transform: `${useTransform ? 'translate(-50%, -50%)' : ''} ${useTransform ? `scale(${scale})` : ``}`,
        overflow: 'hidden'
    };

    return (
        <Box
            ref={container.ref}
            sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: forceOverflow ?? (!useTransform ? 'auto' : 'hidden') // ✅ forceOverflow 있으면 적용
            }}
        >
            {container.width > 0 && container.height > 0 && width > 0 && height > 0 &&
                <Box sx={{ width, height, ...(useTransform ? scaleTransform : originalTransform) }}>
                    {children}
                </Box>
            }
            {enableDebugButton &&
                <Stack
                    spacing={1}
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        m: 1,
                        opacity: optionButtonState?.opacity
                    }}
                    onMouseOver={onMouseOverHandler}
                >
                    <Button variant="contained" size="small" onClick={onClickHandler}>
                        {useTransform ? `원본 (${width}x${height})` : `채우기 (${container.width}x${container.height})`}
                    </Button>
                </Stack>
            }
        </Box>
    );
}